module.exports = __webpack_public_path__ + "static/media/Engbanner@2x.a6765119.png";